import React from "react";
import { motion } from "framer-motion";
import { PageHeader } from "../components/PageHeader";
import { IMAGES } from "../lib/clinic";

const ITEMS = [
  { src: IMAGES.doctor_desk, caption: "Personalized patient-focused consultation." },
  { src: IMAGES.group_coats, caption: "Professional healthcare collaboration." },
  { src: IMAGES.doctor_podium, caption: "Public health awareness and education." },
  { src: IMAGES.womens_day, caption: "Community health and awareness initiatives." },
  { src: IMAGES.selfie, caption: "Medical mentorship & collaborative care." },
];

const Gallery = () => {
  return (
    <div data-testid="gallery-page">
      <PageHeader
        eyebrow="Gallery"
        title="Moments from the clinic & beyond."
        subtitle="A glimpse into Dr. Avril's practice, public speaking, mentorship and community health initiatives."
        breadcrumbs={["Gallery"]}
      />

      <section className="py-20 md:py-28 bg-paper">
        <div className="container-x">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-8 space-y-8" data-testid="gallery-masonry">
            {ITEMS.map((it, i) => (
              <motion.figure
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: (i % 6) * 0.05 }}
                className="break-inside-avoid"
                data-testid={`gallery-item-${i}`}
              >
                <div className="overflow-hidden">
                  <img
                    src={it.src}
                    alt={it.caption}
                    className="w-full object-cover transition-transform duration-700 hover:scale-[1.02] grayscale-[6%]"
                    loading="lazy"
                  />
                </div>
                <figcaption className="mt-4">
                  <p className="text-[12px] tracking-[0.18em] uppercase text-brand-goldDark heading-serif italic">
                    {it.caption}
                  </p>
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
